import { render, staticRenderFns } from "./popup_chat.vue?vue&type=template&id=b3a5b1ea&scoped=true&"
import script from "./popup_chat.vue?vue&type=script&lang=js&"
export * from "./popup_chat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a5b1ea",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ChatApp: require('/home/runner/work/mywellness-fiesta-2026/mywellness-fiesta-2026/user/components/chat/ChatApp.vue').default})
